
export class DynamicDraggingColumn<T> {
    allowReordering?: boolean;
    dropFeedbackMode?: string;
    onReorder?: <T, U>(param: T | void) => U | void;

    constructor(source: Partial<DynamicDraggingColumn<T>>) {
        Object.assign(this, source);
    }
}